export default "__VITE_ASSET__8e175371__"